import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { presetPriceMinor } from "@/lib/paymentPresets";

export default function SalePaymentPreset({ basePrice, currency, onApply, onClear, initialPresetId = "" }) {
  const [presets, setPresets] = useState([]), [selected, setSelected] = useState(initialPresetId || "");
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    api.get("/payment-presets").then(({ data }) => { if (active) setPresets(data.filter(p => p.active)); })
      .catch(e => { if (active) setError(formatApiError(e)); });
    return () => { active = false; };
  }, []);
  const preset = presets.find(p => p.id === selected);
  const price = preset ? presetPriceMinor(Math.round(basePrice * 100), preset.price_adjustment_percent) / 100 : basePrice;
  return <div className="border-b border-slate-200 pb-3 space-y-2">
    <label className="block text-sm">Ödeme şablonu<select className="input mt-1" value={selected} onChange={e => { setSelected(e.target.value); onClear?.(); }}><option value="">Özel ödeme koşulları</option>{presets.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}</select></label>
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    {preset && <><p className="text-sm text-slate-600">%{preset.upfront_percent} peşinat · {preset.installment_count} taksit · {preset.interval_months} ayda bir · Fiyat farkı %{preset.price_adjustment_percent}</p>
      <button type="button" className="text-sm font-semibold text-amber-800 underline" onClick={() => onApply(preset, price)}>Önerilen fiyatı uygula: {new Intl.NumberFormat("tr-TR", { style: "currency", currency }).format(price)}</button></>}
  </div>;
}
